import { render, staticRenderFns } from "./entruckEdit.vue?vue&type=template&id=48d9de3c&scoped=true&"
import script from "./entruckEdit.vue?vue&type=script&lang=js&"
export * from "./entruckEdit.vue?vue&type=script&lang=js&"
import style0 from "./entruckEdit.vue?vue&type=style&index=0&id=48d9de3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d9de3c",
  null
  
)

export default component.exports